import React, { ReactNode } from "react";
import { useField, useFormikContext } from "formik";
import Error from "./FormItemError";
import Radio from "../components/Radio";
import FieldProps from "./FieldProps";
import Label from "../components/Label";

interface RadioProps extends FieldProps {
  children: ReactNode;
  buttonStyle?: "outline" | "solid";
  size?: number | undefined;
  disabled?: boolean;
  defaultValue?: any;
  value?: any;
  onRadioChange?: (e: any) => void;
  labelClassname?: string;
}

const FormikRadioField: React.FC<RadioProps> = (props) => {
  const [field, meta] = useField(props);
  const context = useFormikContext();
  const showError = meta.touched && meta.error;

  const onChange = (e: any) => {
    context.setFieldValue(props.name, e.target.value);
    if (props.onRadioChange) props.onRadioChange(e);
  };

  return (
    <>
      {props.label && (
        <Label
          htmlFor={props.id || props.name}
          className={props.labelClassname}
        >
          {props.label}
        </Label>
      )}
      <Radio {...props} onChange={onChange}>
        {props.children}
      </Radio>
      {showError && <Error>{meta.error}</Error>}
    </>
  );
};

export default FormikRadioField;
